import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Api } from '../../../typings/api';

interface FileFormatProps {
	type: Api.AssetItemFileTypes;
	fileFormat: Api.AssetItemFileFormats;
	isProposal: boolean;
}

const FileFormat = ({ type, fileFormat, isProposal }: FileFormatProps) => {
	let format = type === Api.AssetItemFileTypes.FILE ? fileFormat : type;

	if (isProposal) {
		format = Api.AssetItemFileTypes.PROPOSAL;
	}

	return <Translate value={`fileFormat.${format}`}/>;
};

export default FileFormat;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/FileFormat/index.tsx